document.addEventListener('DOMContentLoaded', () => {
  const inputs = document.querySelectorAll('[qty]');

  inputs.forEach((input) => {
    const buttons = input.querySelectorAll('button');
    const qty = input.querySelector('input');

    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        const direction = target.name;
        const value = +qty.value;

        if (direction === 'plus') {
          qty.value = value + 1;
        }
        if (direction === 'minus') {
          qty.value = Math.max(1, value - 1);
        }
      });
    });
  });
});
